export const rootUrl = process.env.REACT_APP_API_ROOT;
export const application = process.env.REACT_APP_APPLICATION;
